import { EditBudgetButton } from './EditBudgetButton';
import { ProblemPropertyIndicator } from './ProblemPropertyIndicator';

export const BorrowerSubmittedAwaitingInspectionOrderDrawPanel = ({
    property,
    styles,
    validateSubmission,
    onProblemPropertyChange,
}) => {
    return (
        <div style={styles.displayFlex}>
            <span style={{ marginRight: 20, color: 'red' }}>NEEDS INSPECTION ORDERED</span>
            <EditBudgetButton
                property={property}
                styles={styles}
                validateSubmission={validateSubmission}
            />
            <ProblemPropertyIndicator
                problemProperty={property.isProblemProperty}
                onChange={onProblemPropertyChange}
            />
        </div>
    );
};
